import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function Hero() {
  return <section id="home" className="relative h-screen min-h-[600px] flex items-center justify-center overflow-hidden" data-id="element-170">
      {/* Background Image */}
      <div className="absolute inset-0 z-0" style={{
      backgroundImage: 'url("https://images.unsplash.com/photo-1503387762-592deb58ef4e?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80")',
      backgroundPosition: 'center',
      backgroundSize: 'cover'
    }} data-id="element-171">
        {/* Dark Overlay */}
        <div className="absolute inset-0 bg-primary/70 mix-blend-multiply" data-id="element-172"></div>
        <div className="absolute inset-0 bg-gradient-to-b from-primary/50 via-transparent to-primary/90" data-id="element-173"></div>
      </div>

      <div className="container mx-auto px-6 md:px-12 relative z-10 pt-20" data-id="element-174">
        <div className="max-w-3xl" data-id="element-175">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} data-id="element-176">
            <span className="inline-block py-1 px-3 border border-accent text-accent text-sm font-medium tracking-widest uppercase mb-6" data-id="element-177">
              Excellence in Construction
            </span>
          </motion.div>

          <motion.h1 className="text-4xl md:text-6xl lg:text-7xl font-serif font-bold text-white leading-tight mb-6" initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.4
        }} data-id="element-178">
            Over 20 Years of{' '}
            <span className="text-accent italic" data-id="element-179">Experience</span> in Remodeling
          </motion.h1>

          <motion.p className="text-lg md:text-xl text-gray-light mb-10 max-w-2xl leading-relaxed" initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.6
        }} data-id="element-180">
            We transform spaces with mastery, managing every detail from permits
            to final finishes to guarantee your complete satisfaction.
          </motion.p>

          <motion.div className="flex flex-col sm:flex-row gap-4" initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.8
        }} data-id="element-181">
            <a href="#contact" className="bg-accent hover:bg-accent-hover text-white px-8 py-4 rounded-sm font-medium text-lg transition-colors flex items-center justify-center gap-2 group" data-id="element-182">
              Get a Quote
              <ArrowRight size={20} className="group-hover:translate-x-1 transition-transform" data-id="element-183" />
            </a>
            <a href="#projects" className="bg-transparent border border-white hover:bg-white hover:text-primary text-white px-8 py-4 rounded-sm font-medium text-lg transition-colors flex items-center justify-center" data-id="element-184">
              View Our Work
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}